module.exports = __webpack_public_path__ + "components/flag/static/square/jp-0c4d9ab670a3bc3791cadd949ddb2f63.svg";